import { render, staticRenderFns } from "./UploadRebateLists.vue?vue&type=template&id=e5b2c7a8"
import script from "./UploadRebateLists.vue?vue&type=script&lang=js"
export * from "./UploadRebateLists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports